import React from 'react';
import { useParams } from 'react-router-dom';
import ItemReport from '.';
const EnhancedItemReport = () => {
    const { id } = useParams()
    return <ItemReport stockId={id} />;
};
export default EnhancedItemReport;